import AuthHelper from '@/helpers/auth';

import DashboardLayout from '@/components/layouts/DashboardLayout';

// auctions
import AuctionList from '@/components/views/Auction/AuctionList';
import AuctionForm from '@/components/views/Auction/AuctionForm';
import CategoryList from '@/components/views/Category/CategoryList';
import CategoryForm from '@/components/views/Category/CategoryForm';
import TagList from '@/components/views/Tag/TagList';
import TagForm from '@/components/views/Tag/TagForm';
import PersonList from '@/components/views/Person/PersonList';
import PersonForm from '@/components/views/Person/Form/PersonForm';
import PersonImport from '@/components/views/Person/PersonImport';
import ItemList from '@/components/views/Item/ItemList';
import Planning from '@/components/views/Planning/Main.vue';

// helpers
import i18n from '@/language/';

const manageRoutes = {
	path: '',
	beforeEnter: AuthHelper.requireAuth,
	component: DashboardLayout,
	children: [{
			path: '/auctions',
			name: 'auctionList',
			component: AuctionList,
			meta: {
				title: i18n.t('auction.list')
			}
    },
    {
      path: '/planning',
      name: 'planning',
      component: Planning,
      meta: {
        title: i18n.t('planning.title')
      }
    },
		{
			path: '/auctions/:auctionId/edit',
			name: 'auctionEdit',
			component: AuctionForm,
			meta: {
				title: i18n.t('auction.edit')
			}
		},
		{
			path: '/auctions/add',
			name: 'auctionAdd',
			component: AuctionForm,
			meta: {
				title: i18n.t('auction.add')
			}
		},
		{
			path: '/items',
			name: 'itemsList',
			component: ItemList,
			meta: {
				title: i18n.t('item.list')
			}
		},
		{
			path: '/categories',
			name: 'categoryList',
			component: CategoryList,
			meta: {
				title: i18n.t('category.list')
			}
		},
		{
			path: '/categories/:categoryId/edit',
			name: 'categoryEdit',
			component: CategoryForm,
			meta: {
				title: i18n.t('category.edit')
			}
		},
		{
			path: '/categories/add',
			name: 'categoryAdd',
			component: CategoryForm,
			meta: {
				title: i18n.t('category.add')
			}
		},
		{
			path: '/tags',
			name: 'tagList',
			component: TagList,
			meta: {
				title: i18n.t('tag.list')
			}
		},
		{
			path: '/tags/:tagId/edit',
			name: 'tagEdit',
			component: TagForm,
			meta: {
				title: i18n.t('tag.edit')
			}
		},
		{
			path: '/tags/add',
			name: 'tagAdd',
			component: TagForm,
			meta: {
				title: i18n.t('tag.add')
			}
		},
		{
			path: '/persons',
			name: 'personList',
			component: PersonList,
			meta: {
				title: i18n.t('person.list')
			}
		},
		{
			path: '/persons/:personId/edit',
			name: 'personEdit',
			component: PersonForm,
			meta: {
				title: i18n.t('person.edit')
			}
		},
		{
			path: '/persons/add',
			name: 'personAdd',
			component: PersonForm,
			meta: {
				title: i18n.t('person.add')
			}
		},
		{
			path: '/persons/import',
			name: 'personImport',
			component: PersonImport,
			meta: {
				title: i18n.t('person.import')
			}
		}
	]
};

export default manageRoutes



// WEBPACK FOOTER //
// ./src/router/routes/manage-routes.js